/**
 * Auto-generated from dark-roast enum types — string-literal union types
 * derived from the Java backend's wire enum values. Do not edit manually.
 * Regenerate with: yarn sync-entities
 */

export enum ExpandFaFilter {
  primary = "primary",
  top = "top",
  all = "all",
}

export const ExpandFaFilterDisplay: Record<ExpandFaFilter, string> = {
  [ExpandFaFilter.primary]: "Primary",
  [ExpandFaFilter.top]: "Top",
  [ExpandFaFilter.all]: "All",
};
